import { useEffect, useState } from "react";

export const useLoading = (state?: boolean) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    setIsLoading(!!state);
  }, [state]);
  return {
    isLoading,
    startLoading: () => {
      setIsLoading(true);
    },
    stopLoading: () => {
      setIsLoading(false);
    },
  };
};
